import { render, staticRenderFns } from "./IndoorDisplayMobile.vue?vue&type=template&id=dc96c5c6&"
import script from "./IndoorDisplayMobile.vue?vue&type=script&lang=ts&"
export * from "./IndoorDisplayMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports